export const setUltimasInternacoes = (state, payload) => {
    state.ultimasInternacoes = payload;
}

export const updateUltimaValidacao = (state, payload) => {
    state.ultimasInternacoes.dados.profissionalValidacao = payload.profissionalValidacao;
    state.ultimasInternacoes.dados.ultimaDataHoraValidacao = payload.ultimaDataHoraValidacao;
}

export const updateUltimaInternacao = (state, payload) => {
    state.ultimasInternacoes.dados.profissionalUltimaInternacao = payload.profissionalInternacao;
    state.ultimasInternacoes.dados.ultimaDataHoraInternacao = payload.ultimaDataHoraInternacao;
}